import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { ToastProvider } from './components/Toast';
import App from './App';
import { fehlerprotokollStarten } from './lib/fehlerprotokoll';
import './index.css';

// Merkt sich die letzten Fehler im Browser — für den Knopf „Feedback".
fehlerprotokollStarten();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
